
import { WorldCountry } from '../types';
import { indonesiaExpanded2 } from './indonesiaExpansion2';

export const indonesiaExpansion3: WorldCountry[] = [
  indonesiaExpanded2
];
